import { IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import * as React from "react";
import { useState } from "react";
import { Create, required, SelectInput, SimpleForm, TextInput, useDataProvider } from "react-admin";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { CommentType } from "./Constant/CommentType";
import { formatDate } from "../../Helper/MomentHelper";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 40,
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em",
  },
  form: {
    [theme.breakpoints.up("xs")]: {
      width: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      marginTop: -30,
    },
  },
  inlineField: {
    display: "inline-block",
    width: "50%",
  },
  ul: {
    listStyleType: "none",
  },
}));

const Comment = ({ onCancel, shopReport, ...props }) => {
  const classes = useStyles();
  const provider = useDataProvider();
  var history = useHistory();
  const [noteData, setNoteData] = useState<any>([] as any);

  const onRedirect = () => {
    onCancel?.();
    return history.location.pathname;
  };

  const getNoteData = async () => {
    const { data } = await provider.getList("shopreportnotes", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DESC" },
      filter: {
        shopReportId__eq: shopReport.wo,
      },
    });
    if (data?.length > 0) {
      let mappedData = data.map(item => ({
        note: item.note,
        createdBy: item.createdBy,
        createdDate: formatDate(item.createdDate),
        type: CommentType.find(x => x.id == item?.type)?.value,
      }));

      setNoteData(mappedData);
    }
  };
  React.useEffect(() => {
    getNoteData();
  }, [shopReport.id]);
  const NotesTimeLine = () => {
    return (
      <Timeline align="left">
        {noteData.map((item, key) => (
          <TimelineItem key={key}>
            <TimelineOppositeContent>
              <Typography color="textSecondary">{item.createdDate}</Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot variant="outlined" color="primary" />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <ul>
                <li
                  style={{
                    width: "100%",
                    whiteSpace: "pre-wrap",
                    lineBreak: "anywhere",
                  }}
                  title={item.note}
                >
                  {item.note}
                </li>
                <li>
                  <strong>
                    <CreatedByField record={item} />
                  </strong>
                </li>
                <li>{item.type}</li>
              </ul>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h6">CREATE NOTE</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <Create title={" "} {...props}>
        <SimpleForm redirect={onRedirect}>
          <TextInput
            source="shopReportId"
            label="Shop Report"
            initialValue={shopReport.wo}
            validate={required()}
            disabled
            fullWidth
            variant="outlined"
          />
          <SelectInput
            label="Type"
            source="type"
            choices={CommentType}
            optionText="value"
            optionValue="id"
            fullWidth
            variant="outlined"
            validate={required()}
          />
          <TextInput
            source="note"
            label="Note"
            validate={required()}
            multiline
            resettable
            fullWidth
            rows={3}
            variant="outlined"
          />
        </SimpleForm>
      </Create>
      <NotesTimeLine />
    </div>
  );
};
export default Comment;
